import { render, staticRenderFns } from "./ConsoleBrand.vue?vue&type=template&id=5a610223&scoped=true&"
import script from "./ConsoleBrand.vue?vue&type=script&lang=js&"
export * from "./ConsoleBrand.vue?vue&type=script&lang=js&"
import style0 from "./ConsoleBrand.vue?vue&type=style&index=0&id=5a610223&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a610223",
  null
  
)

component.options.__file = "ConsoleBrand.vue"
export default component.exports